import { get, isEqual } from 'lodash';

import {
    claimedDomainsWithCountsIsLoadingSelector,
    claimedParamsSelector,
    claimedTotalPagesSelector,
    claimedFilterParamsSelector,
} from '../../common/selectors/claimed-domains-with-counts-selectors';

import { fetchDomainsWithCounts } from '../../common/actions/domains-with-counts-action-creators';

import {
    getQueryParams,
    updateQueryParam
} from '../../utils/query-param-utils';

import { DOMAIN_STATUS_APPROVED, DOMAIN_HIERARCHY_PARENT } from '../../common/constants/definitions';

const DEFAULT_CLAIMED_DOMAINS_PARAMS = {
    domainHierarchy: DOMAIN_HIERARCHY_PARENT,
    domainStatus: DOMAIN_STATUS_APPROVED,
    pageNum: 1,
    pageSize: 50,
};

function fetchClaimedDomains( params, filters = {} ){
    const fetchParams = {
        ...DEFAULT_CLAIMED_DOMAINS_PARAMS,
        ...params,
    };

    return ( dispatch ) => {
        return dispatch( fetchDomainsWithCounts( fetchParams, filters ) );
    };
}

export function fetchClaimedDomainsIfNeeded( params, filters = {} ){
    // domainHierarchy determines page content, so we're storing it as a url query param
    let { domainHierarchy } = getQueryParams();
    if( !domainHierarchy ){
        domainHierarchy = DOMAIN_HIERARCHY_PARENT;
        updateQueryParam( { domainHierarchy } );
    }

    const fetchParams = {
        domainHierarchy,
        ...params
    };

    return ( dispatch, getState ) => {
        const state = getState();

        const prevParams = claimedParamsSelector( state );
        const prevFilters = claimedFilterParamsSelector( state );

        const isLoading = claimedDomainsWithCountsIsLoadingSelector( state );
        const totalPages = claimedTotalPagesSelector( state );

        // if totalPages === 0 in the store, we always want to make the next fetch to recover from the no data state
        const pageNumChanged = ( get( fetchParams, 'pageNum', 0 ) <= totalPages ) || ( totalPages === 0 );
        const fetchOrFilterParamsChanged = !isEqual( fetchParams, prevParams ) || !isEqual( filters, prevFilters );

        if( !isLoading &&
            fetchOrFilterParamsChanged &&
            pageNumChanged
        ){
            return dispatch( fetchClaimedDomains( fetchParams, filters ) );
        }
        else{
            return Promise.resolve();
        }
    };
}

export function refreshClaimedDomains(){
    return ( dispatch, getState ) => {
        const state = getState();

        const params = claimedParamsSelector( state );
        const filterParams = claimedFilterParamsSelector( state );

        if( params ){
            // fetch first page on refresh -- the reducer handles resetting the array of ids we preserve
            const finalParams = {
                ...params,
                pageNum: 1
            };

            return dispatch( fetchClaimedDomains( finalParams, filterParams ) );
        }
    };
}
